'use client';

// Stub performance component kept for backward-compat. The previous
// implementation logged every resource-timing entry to the browser console,
// which fires dozens of times per page and tanks the Lighthouse
// "Browser errors logged to the console" Best Practices audit with no
// corresponding benefit (the data was only ever console.log'd, never sent
// to an analytics endpoint). Wire a real sink here (e.g. `web-vitals` npm
// package posting to /api/metrics) before re-enabling observation.
export default function WebVitals() {
  return null;
}

// Image optimization helper
export const getOptimizedImageUrl = (
  url: string,
  width: number = 800,
  quality: number = 75,
): string => {
  if (!url) return '';

  // If it's already optimized, return as is
  if (url.includes('_next/image') || url.includes('?w=') || url.includes('?width=')) {
    return url;
  }

  // For Next.js image optimization
  const fullUrl = url;

  return `/_next/image?url=${encodeURIComponent(fullUrl)}&w=${width}&q=${quality}`;
};

// Preload critical images
export const preloadCriticalImages = (images: string[]) => {
  if (typeof window === 'undefined') return;

  images.forEach((src) => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};
